export default "__VITE_ASSET__hsHB_boS__"